import React, { useState, useCallback } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navigation } from "./components/Navigation";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { Home } from "./pages/Home";
import { HowItWorks } from "./pages/HowItWorks";
import { Features } from "./pages/Features";
import { Portfolio } from "./pages/Portfolio";
import { Pricing } from "./pages/Pricing";
import { ROI } from "./pages/ROI";
import { BookDemo } from "./pages/BookDemo";
import { WebsiteGrader } from "./pages/WebsiteGrader";
import { About } from "./pages/About";
import { Admin } from "./pages/Admin";
import { PromoPal } from "./components/PromoPal";
import { MonsterWidget } from "./components/MonsterWidget";
import { IntroSplash } from "./components/IntroSplash";

const AppContent = () => {
  const location = useLocation();
  const isAdmin = location.pathname === '/admin';

  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Navigation />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/features" element={<Features />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/roi" element={<ROI />} />
        <Route path="/book-demo" element={<BookDemo />} />
        <Route path="/grade-my-site" element={<WebsiteGrader />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <PromoPal />}
      {!isAdmin && <MonsterWidget />}
    </>
  );
};

function App() {
  const [showIntro, setShowIntro] = useState(() => {
    return !sessionStorage.getItem('intro_seen');
  });

  const handleIntroComplete = useCallback(() => {
    setShowIntro(false);
    sessionStorage.setItem('intro_seen', '1');
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
